import { environment } from '../../../../../infra/environment/environment';
import { NoticeAPI } from '../../../services/notice-api';

export class NoticesService {
  private api: NoticeAPI;

  constructor() {
    this.api = new NoticeAPI(environment);
  }

  getActiveNotices = () => {
    return this.api.getActiveNotices();
  };
}
